﻿import {InstallationId} from "../../nominalTypes/InstallationId";
import {ForgetPassword} from "../../types/arguments/ForgetPassword";
import {RequestSignIn} from "../../types/arguments/RequestSignIn";
import {RequestSignUp} from "../../types/arguments/RequestSignUp";
import {VerifyUserExistsResult} from "../../types/VerifyUserExistsResult";
import IPermitsAuthentication from "../IPermitsAuthentication";
import {PermitsFrontClient} from "./PermitsFrontClient";

export class PermitsAuthentication implements IPermitsAuthentication {
	_client: PermitsFrontClient;

	constructor(client: PermitsFrontClient) {
		this._client = client;
	}

	forgetPassword(data: ForgetPassword, signal?: AbortSignal | undefined): Promise<void> {
		return this._client.nullFetch("authentication/forget-password", "POST", data, {
			signal: signal
		});
	}

	isRegistered(installationId: InstallationId, email: string, signal?: AbortSignal | undefined): Promise<VerifyUserExistsResult> {
		return this._client.jsonFetch(`authentication/${installationId}/${encodeURIComponent(email)}/is-registered`, "GET", null, {
			signal: signal
		});
	}

	signIn(data: RequestSignIn, signal?: AbortSignal | undefined): Promise<void> {
		return this._client.nullFetch("authentication/sign-in", "POST", data, {
			signal: signal
		});
	}

	signOff(signal?: AbortSignal | undefined): Promise<void> {
		return this._client.nullFetch("authentication/sign-out", "POST", null, {
			signal: signal
		});
	}

	signUp(data: RequestSignUp, signal?: AbortSignal | undefined): Promise<string> {
		return this._client.jsonFetch("authentication/sign-up", "POST", data, {
			signal: signal
		});
	}
}
